import { Table, Row, Col, message, Modal, Space, Tag, Pagination, Button } from "antd";
import { DeleteOutlined, ExclamationCircleOutlined, CheckOutlined, EyeOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import axios from '../../../utils/axios';
import dayjs from "dayjs";

export default function ContactDashboard() {
  const [contacts, setContacts] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 10 });

  const fetchContacts = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/contact/getAll`, { params: pagination });
      setContacts(res?.data || {});
    } catch {
      message.error("Lỗi tải dữ liệu!");
    }
  };

  const markAsRead = async (id) => {
    await axios.put(`${process.env.REACT_APP_API_URL}/contact/read/${id}`);
    message.success("Đã đánh dấu đã đọc!");
    fetchContacts();
  };

  const removeContact = async (id) => {
    await axios.delete(`${process.env.REACT_APP_API_URL}/contact/delete/${id}`);
    message.success("Xóa thành công!");
    fetchContacts();
  };

  const confirmDelete = (id) => {
    Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content: "Bạn có chắc chắn xoá liên hệ này?",
      okText: "Xác nhận",
      cancelText: "Huỷ",
      onOk: () => removeContact(id),
    });
  };

  useEffect(() => {
    fetchContacts();
  }, [pagination]);

  const columns = [
    { title: "ID", dataIndex: "id", key: "id", width: 60, sorter: (a, b) => a.id - b.id },
    { title: "Họ tên", dataIndex: "name", key: "name", width: 150 },
    { title: "Email", dataIndex: "email", key: "email", width: 180 },
    { title: "SĐT", dataIndex: "phone", key: "phone", width: 120 },
    {
      title: "Nội dung", dataIndex: "message", key: "message", width: 250,
      render: (text) => <div className="max-w-[250px] truncate">{text}</div>
    },
    {
      title: "Trạng thái", dataIndex: "is_read", key: "is_read", width: 120,
      filters: [{ text: 'Chưa đọc', value: 0 }, { text: 'Đã đọc', value: 1 }],
      onFilter: (value, record) => record.is_read === value,
      render: (_, record) => record.is_read ?
        <Tag color="green">Đã đọc</Tag> :
        <Tag color="red">Chưa đọc</Tag>
    },
    {
      title: "Ngày gửi", dataIndex: "create_at", key: "create_at", width: 120,
      sorter: (a, b) => dayjs(a.create_at) - dayjs(b.create_at),
      render: (_, record) => dayjs(record.create_at).format("DD/MM/YYYY")
    },
    {
      title: "Thao tác", key: "action", width: 120,
      render: (_, record) => (
        <Space>
          {!record.is_read && (
            <Button type="link" icon={<CheckOutlined />} onClick={() => markAsRead(record.id)} className="text-green-500" />
          )}
          <Button type="link" danger icon={<DeleteOutlined />} onClick={() => confirmDelete(record.id)} />
        </Space>
      )
    },
  ];

  return (
    <>
      <Row gutter={10} className="mb-2">
        <Col flex={1}>
          <div className="text-[20px] font-medium pb-5 pt-5">Quản lý liên hệ</div>
        </Col>
      </Row>
      <div className="w-full h-full mt-5 pb-20 relative">
        <Table
          className="custom-table"
          dataSource={contacts?.data}
          columns={columns}
          pagination={false}
          rowKey="id"
          rowClassName={(record) => !record.is_read ? 'bg-blue-50' : ''}
        />
        <Pagination
          className="flex justify-center absolute inset-x-0 bottom-10"
          current={pagination.page}
          total={contacts?.total}
          pageSize={pagination.pageSize}
          showSizeChanger
          onChange={(p, ps) => setPagination({ page: p, pageSize: ps })}
        />
      </div>
    </>
  );
}
